import { fetch } from '../../utils'
import { SecureStorage } from '../../utils'
import Config from '../../config'
import history from '../../views/history'

const env = process.env
const HOSTNAME = env.REACT_APP_NODE_ENV === 'production'? env.REACT_APP_API_PRODUCTION : env.REACT_APP_API_STAGING

export const submitBarcode = input => {
  const query = `mutation { assumeControl(barcode: "${input.barcode}") { id rooms { id } }}`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      return error
    })
}

export const fetchRoom = id => {
  const query = `{ room (id: ${id}) {
    id covers { id }
    currentTemp
    home
    setpoint
    name
    nickname
    sleep 
    schedules {
      away
      dayOfWeek
      home1
      home2
      sleep
    }}
  }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      // User should send to login if error come on room payload
      if (payload.errors && payload.errors && payload.errors[0] && payload.errors[0].message === 'unauthorized') {
        localStorage.clear()
        history.push('/login')
      } else {
        /**
        Store secure encrypted data in local storage to offile load after decryption by security token from ENV variable
        For a single user room data should not be large 
        **/
        const secureData = SecureStorage.encrypt(JSON.stringify(payload))
        localStorage.setItem(Config.LocalStorageKeys.Room, secureData)
      }
      return payload
    })
    .catch(error => {
      // User should send to login if error come on room payload
      if (error && error[0] && error[0].message === 'unauthorized') {
        localStorage.clear()
        history.push('/login')
      }
      throw error
    })
}

export const fetchRooms = () => {

  const query = `{
    rooms{
      id covers { id barcode }
      currentTemp
      name
      nickname
      schedules {
        away
        dayOfWeek
        home1
        home2
        sleep
      }
      home
      sleep
      setpoint
    }
  }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      // User should send to login if error come on rooms payload
      if (payload.errors && payload.errors && payload.errors[0] && payload.errors[0].message === 'unauthorized') {
        localStorage.clear()
        history.push('/login')
      } else {
        /**
        Store secure encrypted data in local storage to offile load after decryption by security token from ENV variable
        For a single user room data should not be large 
        **/
        const secureData = SecureStorage.encrypt(JSON.stringify(payload))
        localStorage.setItem(Config.LocalStorageKeys.Rooms, secureData)
      }
      return payload
    })
    .catch(error => {
      // User should send to login if error come on rooms payload
      if (error && error[0] && error[0].message === 'unauthorized') {
        localStorage.clear()
        history.push('/login')
      }
      throw error
    })
}

export const setTemperature = data => {
  const query = `mutation { setTarget(home: ${data.homeTemp}, Id: ${data.id}, sleep: ${
    data.sleepTemp
  }) {  home sleep } }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      throw error
    })
}

export const setSchedule = data => {
  const query = `mutation {
    setSchedule(dayOfWeek: ${data.dayOfWeek}, home1: "${data.home1}", away: "${data.away}", home2: "${
    data.home2
  }", roomId: ${data.id}, sleep: "${data.sleep}") {
      away
      dayOfWeek
      home1
      home2
      room {  id  }
      sleep 
    }}`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      throw error
    })
}

export const setSetPoint = data => {
  const query = `mutation{setSetpoint(id:${data.id}, setpoint: ${data.setpoint}){id setpoint currentTemp}}`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      throw error
    })
}

export const setNickName = data => {
  data.nickname = data.nickname || data.name
  const query = `mutation{ changeNick(id: ${data.id}, nickname: "${data.nickname}"){ id }}`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then((payload) => {
      return payload 
    })
    .catch(error => {
      throw error
    })
}



// WEBPACK FOOTER //
// ./src/store/cozy/api.js